import React from "react";
import { FramesBar } from "@shared/components/NewFrameBar/FramesBar";
import { MapPane } from "@shared/components/MapPane";
import { Sidebar } from "@shared/Sidebar/Sidebar";
import { Toolbar } from "@shared/Toolbar/Toolbar";

export const DesktopLayout = () => {
	return (
		<div className="flex flex-row flex-1">
			<Toolbar />
			<div className="flex flex-col flex-1">
				<div className={"flex-1 flex flex-col"}>
					<div className={"p-2 pl-0 flex-1"}>
						<MapPane />
					</div>
				</div>
				<FramesBar />
			</div>
			<Sidebar />
		</div>
	);
};
